class TryBuy {
  numberOfDays: number;

  constructor(tryBuyData?) {
    if (tryBuyData) {
      this.numberOfDays = tryBuyData.numberOfDays;
    }
  }
}

export class Discount {

  _id: string;
  title: string;
  identifier: string;
  productValue: number;
  discountedValue: number;
  discountAmount: number;
  deal: string;
  trybuy: TryBuy;
  type: string;
  priority: number;
  automaticDiscount: boolean;
  extraBalance: number;
  totalCredit: number;
  daysToExpire: number;
  expirationDate: Date;
  formatedExpirationDate: string;
  degustation: number;

  allowSaleWithoutPayment: boolean;
  saleMessageInfo: string;

  constructor(discount?: any) {
    if (discount) {
      this.identifier = discount.identifier;
      this.productValue = discount.productValue;
      this.discountedValue = discount.discountedValue;
      this.discountAmount = discount.discountAmount;
      this.trybuy = discount.trybuy ?  new TryBuy(discount.trybuy) : null;
      this.type = discount.type;
      this.priority = discount.priority;
      this._id = discount._id;
      this.automaticDiscount = discount.automaticDiscount;
      this.deal = discount.deal;
      this.allowSaleWithoutPayment = discount.allowSaleWithoutPayment;
      this.saleMessageInfo = discount.saleMessageInfo;
      this.degustation = discount.trybuy ? discount.trybuy.numberOfDays : null;
      const rate = discount.deal ? Number(discount.deal.replace('%', '').replace('R$', '').replace(' ', '')) : null;
      this.extraBalance = Number((this.productValue * rate) / 100);
      this.totalCredit = this.productValue + this.extraBalance;
      this.daysToExpire = discount.numberOfDays;
      this.expirationDate = new Date(discount.expirationDate);
      this.formatedExpirationDate = discount.formatedExpirationDate;
    }
  }
}
